
export default function Testimonials() {
  const testimonials = [
    {
      name: 'Maria Gonzalez',
      role: 'Bride',
      image: 'https://public.readdy.ai/ai/img_res/63b56e12ac3bc8a870a691a190067d97.jpg',
      text: 'The service was exceptional. Every detail of our wedding was perfect thanks to the Elegance Staffing team. The waiters were very professional and the food was delicious.',
      rating: 5
    },
    {
      name: 'Carlos Rodriguez',
      role: 'Events Director',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20confident%20hispanic%20businessman%20in%20his%20forties%20formal%20suit%20executive%20headshot%20clean%20simple%20background%20natural%20studio%20lighting%20high%20quality%20professional%20photography%20friendly%20approachable%20smile%20polished%20corporate%20appearance&width=200&height=200&seq=t2&orientation=squarish',
      text: 'We have worked with them on multiple corporate events and they always exceed our expectations. Their professionalism and attention to detail are unmatched.',
      rating: 5
    },
    {
      name: 'Ana Martinez',
      role: 'Birthday Celebration',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20hispanic%20woman%20in%20her%20fifties%20warm%20friendly%20smile%20confident%20expression%20business%20professional%20headshot%20clean%20simple%20background%20natural%20lighting%20high%20quality%20photography%20approachable%20demeanor%20sophisticated%20appearance&width=200&height=200&seq=t3&orientation=squarish',
      text: 'My 50th birthday was memorable thanks to this wonderful team. The decoration was impressive and all my guests were delighted with the service.',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-[#F5F5F0] to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-6 py-2 bg-[#D4AF37]/10 rounded-full border border-[#D4AF37]/20">
            <span className="text-[#D4AF37] text-sm font-semibold tracking-wide">TESTIMONIALS</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold mb-6">
            What Our<br />Clients Say
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Our clients' satisfaction is our greatest reward
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-[#D4AF37]">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D4AF37] text-xl"></i>
                ))}
              </div>

              <p className="text-gray-600 leading-relaxed italic">"{testimonial.text}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
